import config from 'config';

export interface ICursorPaginationMetaData {
  hasNextPage?: boolean;
  hasPreviousPage?: boolean;
  endCursor?: string | null;
  startCursor?: string | null;
  total?: number;
}

export interface ICursorPaginatedData<T> {
  data: T[];
  meta?: ICursorPaginationMetaData;
}

export interface ICursorPaginatedInput {
  cursor?: string | null;
  limit?: number;
}

type FetchFunctionType<T> = (
  input: ICursorPaginatedInput
) => Promise<ICursorPaginatedData<T>>;

export async function loadAllCursorPaginatedChunks<T>(
  fetchChunk: FetchFunctionType<T>,
  chunkSize: number = config.PAGINATION.BATCH_SIZE
): Promise<T[]> {
  const result: T[] = [];
  let hasNextPage = true;
  let cursor: string | undefined = undefined;

  while (hasNextPage) {
    const page = await fetchChunk({ cursor, limit: chunkSize });
    const data = page?.data ?? [];
    if (data.length === 0) {
      break;
    }
    result.push(...(page?.data ?? []));
    hasNextPage = !!page?.meta?.hasNextPage;
    cursor = page?.meta?.endCursor ?? undefined;
  }

  return result;
}
